import { useState, useEffect } from 'react';
import popupApi from '../api/popupApi';

const usePopup = () => {
  const [currentPopup, setCurrentPopup] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAndShowPopup = async () => {
      try {
        // Fetch active popups
        const popups = await popupApi.getActivePopups();

        if (popups.length === 0) {
          setIsLoading(false);
          return;
        }

        // Filter and sort popups
        const now = new Date();
        const eligiblePopups = popups.filter(popup => {
          // Check if enabled
          if (!popup.enabled) return false;

          // Check date range
          const startDate = new Date(popup.startDate);
          const endDate = new Date(popup.endDate);
          if (now < startDate || now > endDate) return false;

          // Check daily schedule if enabled
          if (popup.dailySchedule?.enabled) {
            const currentTime = now.toTimeString().slice(0, 5); // HH:MM
            const startTime = popup.dailySchedule.startTime;
            const endTime = popup.dailySchedule.endTime;

            if (currentTime < startTime || currentTime > endTime) return false;
          }

          return true;
        });

        if (eligiblePopups.length === 0) {
          setIsLoading(false);
          return;
        }

        // Sort by priority (highest first) and get the first one
        const sortedPopups = eligiblePopups.sort((a, b) => b.priority - a.priority);
        const selectedPopup = sortedPopups[0];

        // Apply delay if specified
        if (selectedPopup.delaySeconds > 0) {
          setTimeout(() => {
            setCurrentPopup(selectedPopup);
            setIsLoading(false);
          }, selectedPopup.delaySeconds * 1000);
        } else {
          setCurrentPopup(selectedPopup);
          setIsLoading(false);
        }

      } catch (error) {
        console.error('Error fetching popups:', error);
        setIsLoading(false);
      }
    };

    checkAndShowPopup();
  }, []);

  const closePopup = () => {
    setCurrentPopup(null);
  };

  return {
    currentPopup,
    isLoading,
    closePopup
  };
};

export default usePopup;
